import React from 'react';
import { Typography } from '@mui/material';
import { ResponsiveBreak } from '../../../../../components';

const NotSupportedLegalRestrictionsMessage: React.FC = () => {
  return (
    <>
      <Typography variant="body1" data-testid="success-text">
        At the moment, the positions don't seem to match your skills, we won't
        be able to proceed with your application.
      </Typography>
      <Typography variant="body1">
        If the situation changes, we would be happy{' '}
        <ResponsiveBreak breakpoint="sm" />
        to reconnect.
      </Typography>
    </>
  );
};

export default NotSupportedLegalRestrictionsMessage;
